import { FC } from 'react';
import Button from '../../yoda-ui/components/Button';
import ExportIcon from '../Icons/ExportIcon';
import {
  adminDashboardFormContainerActionsStyle,
  adminDashboardFormContainerContentStyle,
  adminDashboardFormContainerStyle,
} from './AdminDashboardFormContainer.style';
import { AdminDashboardFormContainerTypes } from './AdminDashboardFormContainer.types';
import ContentCard from 'components/ContentCard';
import LargeContainer from 'components/Layout/LargeContainer';
import Box from 'yoda-ui/components/Box';
import { YodaFormProvider } from 'yoda-ui/yodaForm';

const AdminDashboardFormContainer: FC<AdminDashboardFormContainerTypes> = ({
  providerFields,
  exportDataButtonConfig,
  exportChartsButtonConfig,
  children,
}) => {
  return (
    <LargeContainer>
      <YodaFormProvider { ...providerFields }>
        <Box sx={ adminDashboardFormContainerStyle }>
          <ContentCard sx={ adminDashboardFormContainerContentStyle }>
            { children }
          </ContentCard>
          <Box sx={ adminDashboardFormContainerActionsStyle }>
            {
              exportDataButtonConfig && (
                <Button
                  sx={ { width: 'fit-content' } }
                  buttonType={ exportDataButtonConfig.buttonProps.buttonType }
                  onClick={ exportDataButtonConfig.buttonProps.onClick }
                  disabled={ exportDataButtonConfig.buttonProps.disabled }
                >
                  { exportDataButtonConfig.label }
                  <ExportIcon style={ { height: '1em', width: 'auto' } } />
                </Button>
              )
            }
            {
              exportChartsButtonConfig && (
                <Button
                  sx={ { width: 'fit-content' } }
                  buttonType={ exportChartsButtonConfig.buttonProps.buttonType }
                  onClick={ exportChartsButtonConfig.buttonProps.onClick }
                  disabled={ exportChartsButtonConfig.buttonProps.disabled }
                >
                  { exportChartsButtonConfig.label }
                  <ExportIcon style={ { height: '1em', width: 'auto' } } />
                </Button>
              )
            }
          </Box>
        </Box>
      </YodaFormProvider>
    </LargeContainer>
  );
};

export default AdminDashboardFormContainer;
